import { Button, Modal } from "react-bootstrap";
import { AssetList } from "../info-technology-process/repair-tools/asset-list";
import { useEffect, useState } from "react";
import { Asset } from "../../../services/department-viags/asset.service";

type AssetModalProps = {
    onClose:  () => void;
    isOpen: boolean;
    onConfirm: (assets: Asset[]) => void;
    // onDateChange: (date: Date) => void;
    // value: Date | undefined,
    // isShowTime: boolean,
}

export const AssetModal = (props: AssetModalProps) => {
    const { onClose, isOpen, onConfirm } = props;
    const [isEditMode, setIsEditMode] = useState(false);
    const [assetList, setAssetList] = useState<Asset[]>([]);

    const onSelectAsset = (assets: Asset[]) => {
      setAssetList(assets);
    }

    const onConfirmSelect = () => {
      onConfirm(assetList);
      onClose();
    }

    useEffect(() => {
      setIsEditMode(false);
    },[isOpen])

    return (
        <Modal
          show={isOpen}
          onHide={onClose}
          size="xl"
          centered
          className="add-folder-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              Danh sách tài sản
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="py-4 px-4">
            <AssetList isEditMode={isEditMode} onSelectAsset={onSelectAsset}/>
          </Modal.Body>
          <Modal.Footer>
          <Button onClick={() => setIsEditMode(!isEditMode)} variant={isEditMode ? "success" : "warning"}>
              {isEditMode ? "Hoàn tất" : "Chỉnh sửa"}
            </Button>
            <Button onClick={onClose} variant="secondary">
              Đóng
            </Button>
            <Button onClick={onConfirmSelect} variant="primary">
              Xác nhận
            </Button>
          </Modal.Footer>
        </Modal>
      );
}